const state = {
  currentTime : 0,
  duration    : 0,
  player      : '',
  visible     : false
}
const getters = {
  currentTime : state => state.currentTime,
  duration    : state => state.duration,
  player      : state => state.player,
  visible     : state => state.visible
}
const mutations = {
  changeCurrentTime (state, value) { state.currentTime = value },
  setDuration       (state, value) { state.duration = value },
  setPlayer         (state, element) { state.player = element },
  changeVisible     (state, value) { state.visible = value }
}
const actions   = {}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/video/store/video-file.js